import React from 'react';
import { withRouter } from 'react-router-dom';
import { observer, inject } from 'mobx-react';
import { withTranslation } from 'react-i18next';
import { ContainerBox, Table, ModalFooter } from 'components';
import { Validate } from "core/utils";
import { ReactNotifications } from "core/logic";
import BaseComponent from '../BaseComponent';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import Switch from 'react-switch';
import './style.scss';
import moment from 'moment';
import {
  MODAL_ID, DATE_FORMAT, NO_DATE, ENABLE_DOCUMENT_DOWNLOAD_DEFAULT, ENABLE_DOCUMENT_DOWNLOAD,
  ENABLE_SPECIFY_CSV_NAME_DEFAULT, ENABLE_SPECIFY_CSV_NAME,
  ENABLE_OTP, ENABLE_OTP_DEFAULT
} from '../../core/utils/constants';
import URL_CONFIG from './../../core/services/config'

const TABLE_ROW_WIDTH_IPADDRESS = {
  NO: "6%",
  IP_ADDRESS: "19%",
  COMMENT: "30%",
  CREATED_DATE: "18%",
  UPDATED_DATE: "18%"
};
const TABLE_ROW_WIDTH_APITOKEN = {
  NO: "6%",
  TOKEN: "37%",
  COMMENT: "30%",
  CREATED_AT: "18%",
};
@inject('commonStore', 'modalStore')
@observer
class GeneralSetting extends BaseComponent {

  constructor(props) {
    super(props);
    this.state = {
      threshold1: 0,
      threshold2: 0,
      apiKey: "",
      dataRetentionPeriod: 0,
      enableDocumentDownload: ENABLE_DOCUMENT_DOWNLOAD_DEFAULT,
      downloadFolderName: "",
      downloadFileName: "<date><time>",
      enableSpecifyCsvName: ENABLE_SPECIFY_CSV_NAME_DEFAULT,
      csvDownloadFolderName: "",
      csvDownloadFileName: "<date><time>",
      enableOtp: ENABLE_OTP_DEFAULT,
      restrictionIpAddress: 1,
      ipadresses: [],
      selectedIndexTab: 0,
    };
    this.restrictionIpAddress = {
      ipAddress: '',
      comment: '',
    };
    this.deletedIpAddresses = [];
  }

  executeLogicAfterRender = async () => {
    const { commonStore: { settingStore, settingStore: { getSetting }, apiTokenStore } } = this.props;
    await apiTokenStore.getTenantTokens();
    await settingStore.cleanIpaddress();
    await settingStore.getIpAddresses();
    const data = await getSetting();
    this.setState({
      threshold1: data.confidence_threshold_1,
      threshold2: data.confidence_threshold_2,
      apiKey: data.apiToken,
      dataRetentionPeriod: data.data_retention_period || 0,
      enableDocumentDownload: data.enable_document_download,
      downloadFolderName: data.download_folder_name || "",
      downloadFileName: data.download_file_name || "<date><time>",
      enableSpecifyCsvName: data.enable_specify_csv_name || 0,
      csvDownloadFolderName: data.csv_download_folder_name || "",
      csvDownloadFileName: data.csv_download_file_name || "<date><time>",
      enableOtp: data.enable_otp || ENABLE_OTP_DEFAULT,
      restrictionIpAddress: data.restriction_ip_address,
      ipadresses: settingStore.ipadresses,
    });
  }

  executeOnDidUpdate = () => {
    // Attach tooltip
    window.$('[data-toggle="tooltip"]').tooltip('destroy');
    window.$('[data-toggle="tooltip"]').tooltip({ container: '.screen-general-setting' });
  }

  handleSelectTab = index => {
    this.setState({ selectedIndexTab: index });
  };

  onChangeTheshold1 = (value) => {
    this.setState({ threshold1: value });
  }

  onChangeTheshold2 = (value) => {
    this.setState({ threshold2: value });
  }

  handleGenerate = async () => {
    const { commonStore: { apiTokenStore: { generateTenantToken } } } = this.props;
    await generateTenantToken();
  }

  handleRemoveKey = () => {
    this.setState({ apiKey: "" });
  }

  onChangeDataRetentionPeriod = (value) => {
    this.setState({ dataRetentionPeriod: value });
  }

  onChangeEnableDocumentDownload = (value) => {
    this.setState({ enableDocumentDownload: value });
  }

  onChangeDownloadFolderName = (value) => {
    this.setState({ downloadFolderName: value });
  }

  onChangeDownloadFileName = (value) => {
    this.setState({ downloadFileName: value });
  }

  onChangeEnableSpecifyCsvName = (value) => {
    this.setState({ enableSpecifyCsvName: value });
  }

  onChangeCsvDownloadFolderName = (value) => {
    this.setState({ csvDownloadFolderName: value });
  }

  onChangeCsvDownloadFileName = (value) => {
    this.setState({ csvDownloadFileName: value });
  }

  onChangeEnableOtp = (value) => {
    this.setState({ enableOtp: value });
  }

  onChangeRestrictionIpAddress = (value) => {
    if (value) {
      this.setState({ restrictionIpAddress: 0 });
    } else {
      this.setState({ restrictionIpAddress: 1 });
    }
  }

  handleSubmit = () => {
    const { t, commonStore: { settingStore, settingStore: { setSetting } } } = this.props;
    const { threshold1, threshold2, apiKey, dataRetentionPeriod, enableDocumentDownload, downloadFolderName, downloadFileName,
      enableSpecifyCsvName, csvDownloadFolderName, csvDownloadFileName, enableOtp, restrictionIpAddress, ipadresses } = this.state;
    const payload = {
      confidence_threshold_1: threshold1,
      confidence_threshold_2: threshold2,
      apiToken: apiKey,
      data_retention_period: dataRetentionPeriod,
      enable_document_download: enableDocumentDownload,
      download_folder_name: downloadFolderName,
      download_file_name: downloadFileName,
      enable_specify_csv_name: enableSpecifyCsvName,
      csv_download_folder_name: csvDownloadFolderName,
      csv_download_file_name: csvDownloadFileName,
      enable_otp: enableOtp,
      restriction_ip_address: restrictionIpAddress
    };
    if (threshold2 && threshold2
      && !Validate.validateThreshold(threshold1, t)
      && !Validate.validateThreshold(threshold2, t)
      && threshold1 >= threshold2
      && !Validate.validateDataRetentionPeriod(dataRetentionPeriod, t)
      && !Validate.validateDownloadFolderName(downloadFolderName, t)
      && !Validate.validateDownloadFileName(downloadFileName, t)
      && !Validate.validateCsvDownloadFolderName(csvDownloadFolderName, t)
      && !Validate.validateCsvDownloadFileName(csvDownloadFileName, t)) {
      setSetting(payload);
    }

    settingStore.saveIpAddress(this.deletedIpAddresses, ipadresses, this.reflashRestrictionIpAddressTable);
  }

  handleCopy = (str) => {
    const { t } = this.props;
    const el = document.createElement('textarea');
    el.value = str;
    el.setAttribute('readonly', '');
    el.style.position = 'absolute';
    el.style.left = '-9999px';
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
    ReactNotifications("info", t("upload.copy"), "");
  }

  renderThresholdErr = (error) => {
    return <div className="row">
      <div className="col-sm-3"></div>
      <div className="col-sm-9 color-red" style={{ height: "40px", lineHeight: "40px" }}>{error}</div>
    </div>
  }

  handleKeyPressForNumber = (event) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);
    if (!/^\d*$/.test(keyValue)) {
      event.preventDefault();
    }
  }

  onFetch = (tableData) => {
    const { commonStore: { settingStore } } = this.props;
    settingStore.updatePagingFiler(tableData);
    this.state.ipadresses = this.sortIpAddresses(tableData);
    this.setState({
      ipadresses: this.state.ipadresses,
    });
  };

  sortIpAddresses = (tableData) => {
    let sortedIpAdresses = [];
    if (tableData.sortKey && tableData.sortKey != 'undefined') {
      switch (tableData.sortKey) {
        case 'ipAddress':
          if (tableData.sortDir == "ASC") {
            sortedIpAdresses = this.state.ipadresses.sort(function (a, b) {
              return (a.ip_address < b.ip_address) ? -1 : 1;
            });
          } else {
            sortedIpAdresses = this.state.ipadresses.sort(function (a, b) {
              return (a.ip_address > b.ip_address) ? -1 : 1;
            });
          }
          break;

        case 'comment':
          if (tableData.sortDir == "ASC") {
            sortedIpAdresses = this.state.ipadresses.sort(function (a, b) {
              return (a.comment < b.comment) ? -1 : 1;
            });
          } else {
            sortedIpAdresses = this.state.ipadresses.sort(function (a, b) {
              return (a.comment > b.comment) ? -1 : 1;
            });
          }
          break;

        case 'createdAt':
          if (tableData.sortDir == "ASC") {
            sortedIpAdresses = this.state.ipadresses.sort(function (a, b) {
              return (a.created_at < b.created_at) ? -1 : 1;
            });
          } else {
            sortedIpAdresses = this.state.ipadresses.sort(function (a, b) {
              return (a.created_at > b.created_at) ? -1 : 1;
            });
          }
          break;

        case 'updatedAt':
          if (tableData.sortDir == "ASC") {
            sortedIpAdresses = this.state.ipadresses.sort(function (a, b) {
              return (a.updated_at < b.updated_at) ? -1 : 1;
            });
          } else {
            sortedIpAdresses = this.state.ipadresses.sort(function (a, b) {
              return (a.updated_at > b.updated_at) ? -1 : 1;
            });
          }
          break;
      }
    } else {
      sortedIpAdresses = this.state.ipadresses.sort(function (a, b) {
        if (a.created_at && b.created_at) {
          return (a.created_at > b.created_at) ? -1 : 1;
        } else if (!a.created_at && !b.created_at) {
          return (a.created_at_temp < b.created_at_temp) ? -1 : 1;
        } else if (!a.created_at) {
          return 1;
        } else if (!b.created_at) {
          return -1;
        }
      });
    }

    return sortedIpAdresses;
  };

  reflashRestrictionIpAddressTable = (tableData) => {
    this.deletedIpAddresses = [];
    this.setState({
      ipadresses: tableData,
    });
  }

  onChangeIpAddress = (value) => {
    document.getElementById("required_msg_ipaddress").textContent = '';
    this.restrictionIpAddress.ipAddress = value;
  }

  onChangeComment = (value) => {
    this.restrictionIpAddress.comment = value;
  }

  onChangeApiToken = (e) => {
    this.apiToken[e.target.name] = e.target.value;
  }

  closeModal = () => {
    const { modalStore } = this.props;
    modalStore.hideAll();
  };

  openAddModal = () => {
    const { modalStore, t } = this.props;
    this.restrictionIpAddress.ipAddress = "";
    this.restrictionIpAddress.comment = "";

    modalStore.show({
      id: MODAL_ID.CREATE_TEAM,
      isOpen: true,
      header: t('general_setting.restriction_ip_address.detail.page_title'),
      onCancel: this.closeModal,
      children: (
        <div className="text-c">
          <div key={"modal-body"} className="modal-body modal-add-item">
            <div className="row">
              <div className="col-sm-1" />
              <div className="col-sm-4 font-bold">
                <span className="color-red">*</span>
                {t("setting_definition.required")}
              </div>
            </div>
            <div className="row" style={{ paddingTop: "15px" }}>
              <div className="col-sm-1" />
              <div className="col-sm-4 font-bold">{t("general_setting.restriction_ip_address.ip")}<span className="color-red">*</span></div>
              <div className="col-sm-6" id="div_item_name">
                <input name="ip_address"
                  type="text"
                  maxLength={18}
                  onChange={(value) => this.onChangeIpAddress(value.target.value)}
                />
                <span className="color-red" id="required_msg_ipaddress"></span>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-1" />
              <div className="col-sm-6" style={{ marginLeft: "33%" }}>
                {t("general_setting.restriction_ip_address.detail.ip.desc_1")}
              </div>
            </div>
            <div className="row">
              <div className="col-sm-1" />
              <div className="col-sm-6" style={{ marginLeft: "33%" }}>
                {t("general_setting.restriction_ip_address.detail.ip.desc_2")}
              </div>
            </div>
            <div className="row">
              <div className="col-sm-1" />
              <div className="col-sm-6" style={{ marginLeft: "43%" }}>
                {t("general_setting.restriction_ip_address.detail.ip.desc_3")}
              </div>
            </div>
            <div className="row">
              <div className="col-sm-1" />
              <div className="col-sm-6" style={{ marginLeft: "43%" }}>
                {t("general_setting.restriction_ip_address.detail.ip.desc_4")}
              </div>
            </div>
            <div className="row"><div className="col-sm-1" /></div>
            <div className="row"><div className="col-sm-1" /></div>
            <div className="row" style={{ paddingTop: "15px" }}>
              <div className="col-sm-1" />
              <div className="col-sm-4 font-bold">{t("general_setting.restriction_ip_address.comment")}</div>
              <div className="col-sm-6" id="div_item_name">
                <input name="ip_address"
                  type="text"
                  maxLength={255}
                  onChange={(value) => this.onChangeComment(value.target.value)}
                />
              </div>
            </div>
          </div>

          <ModalFooter key={"modal-footer"}
            saveButtonText={t('common.create')}
            onConfirm={() => this.onConfirmAdd()}
            saveButtonClass="btn-primary"
          />
        </div>
      ),
      type: 'medium'
    });
  };

  openEditModal = (id, ipaddress, comment) => {
    const { modalStore, t } = this.props;
    this.restrictionIpAddress.ipAddress = ipaddress;
    this.restrictionIpAddress.comment = comment;

    modalStore.show({
      id: MODAL_ID.CREATE_TEAM,
      isOpen: true,
      header: t('general_setting.restriction_ip_address.detail.page_title'),
      onCancel: this.closeModal,
      children: (
        <div className="text-c">
          <div key={"modal-body"} className="modal-body modal-add-item">
            <div className="row">
              <div className="col-sm-1" />
              <div className="col-sm-4 font-bold">
                <span className="color-red">*</span>
                {t("setting_definition.required")}
              </div>
            </div>
            <div className="row" style={{ paddingTop: "15px" }}>
              <div className="col-sm-1" />
              <div className="col-sm-4 font-bold">{t("general_setting.restriction_ip_address.ip")}<span className="color-red">*</span></div>
              <div className="col-sm-6" id="div_item_name">
                <input name="ip_address"
                  type="text"
                  maxLength={18}
                  onChange={(value) => this.onChangeIpAddress(value.target.value)}
                  defaultValue={ipaddress}
                />
                <span className="color-red" id="required_msg_ipaddress"></span>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-1" />
              <div className="col-sm-6" style={{ marginLeft: "33%" }}>
                {t("general_setting.restriction_ip_address.detail.ip.desc_1")}
              </div>
            </div>
            <div className="row">
              <div className="col-sm-1" />
              <div className="col-sm-6" style={{ marginLeft: "33%" }}>
                {t("general_setting.restriction_ip_address.detail.ip.desc_2")}
              </div>
            </div>
            <div className="row">
              <div className="col-sm-1" />
              <div className="col-sm-6" style={{ marginLeft: "43%" }}>
                {t("general_setting.restriction_ip_address.detail.ip.desc_3")}
              </div>
            </div>
            <div className="row">
              <div className="col-sm-1" />
              <div className="col-sm-6" style={{ marginLeft: "43%" }}>
                {t("general_setting.restriction_ip_address.detail.ip.desc_4")}
              </div>
            </div>
            <div className="row"><div className="col-sm-1" /></div>
            <div className="row"><div className="col-sm-1" /></div>
            <div className="row" style={{ paddingTop: "15px" }}>
              <div className="col-sm-1" />
              <div className="col-sm-4 font-bold">{t("general_setting.restriction_ip_address.comment")}</div>
              <div className="col-sm-6" id="div_item_name">
                <input name="ip_address"
                  type="text"
                  maxLength={255}
                  onChange={(value) => this.onChangeComment(value.target.value)}
                  defaultValue={comment}
                />
              </div>
            </div>
          </div>

          <ModalFooter key={"modal-footer"}
            saveButtonText={t('common.save')}
            onConfirm={() => this.onConfirmEdit(id)}
            saveButtonClass="btn-primary"
          />
        </div>
      ),
      type: 'medium'
    });
  };

  openComfirmModal = (id) => {
    const { modalStore, t } = this.props;
    modalStore.show({
      id: MODAL_ID.REMOVE,
      isOpen: true,
      header: t('general_setting.restriction_ip_address.remove_confirm'),
      onCancel: this.closeModal,
      children: (
        <div className="text-c">
          <div key={"modal-body"} className="modal-body">
            <span>{t('general_setting.restriction_ip_address.remove_confirm_msg')}</span>
          </div>
          <ModalFooter key={"modal-footer"}
            saveButtonText={t('individual_model_mng.remove')}
            onConfirm={() => this.onConfirmDeleteById(id)}
            cancelButtonText={t('definition.cancel')}
            onCancel={this.closeModal}
            saveButtonClass="btn-primary"
          />
        </div>
      ),
      type: 'small'
    });
  };

  onConfirmDeleteById = (id) => {
    const { ipadresses } = this.state;
    let newIpAdresses = [];
    for (const elem of ipadresses) {
      if (elem.id == id) {
        if ((!elem.status || elem.status == 'undefined') ||
          (elem.status && elem.status == 2)) {
          this.deletedIpAddresses.length += 1;
          this.deletedIpAddresses[this.deletedIpAddresses.length - 1] = elem;
        }
      } else {
        newIpAdresses.length += 1;
        newIpAdresses[newIpAdresses.length - 1] = elem;
      }
    }
    this.setState({ ipadresses: newIpAdresses });
    this.closeModal();
  }

  onConfirmAdd = () => {
    const { t, commonStore: { settingStore } } = this.props;
    const { ipadresses } = this.state;
    let trimedIpAddress = this.restrictionIpAddress.ipAddress.trim();
    let trimedComment = this.restrictionIpAddress.comment.trim();
    if (trimedIpAddress == "") {
      document.getElementById("required_msg_ipaddress").textContent = t("validate.field_is_empty");
      return;
    }
    let errmsg = Validate.validateIpAddress(trimedIpAddress, t);
    if (errmsg !== "") {
      document.getElementById("required_msg_ipaddress").textContent = errmsg;
      return;
    }
    if (!this.isUniqueIpAddress(trimedIpAddress)) {
      document.getElementById("required_msg_ipaddress").textContent = t("general_setting.restriction_ip_address.detail.ip_duplicated");
      return;
    }
    ipadresses.length += 1;
    let newElement = {
      id: this.uniqueId(5),
      ip_address: trimedIpAddress,
      comment: trimedComment,
      created_at: null,
      updated_at: null,
      created_at_temp: new Date().getTime(),
      status: 1,
    }
    ipadresses[ipadresses.length - 1] = newElement;
    this.setState({ ipadresses });

    this.closeModal();
    this.state.ipAddress = "";
    this.state.comment = "";
  }

  isUniqueIpAddress = (newIpAddress) => {
    const { ipadresses } = this.state;
    for (const elem of ipadresses) {
      if (elem.ip_address == newIpAddress) {
        return false;
      }
    }
    return true;
  }

  uniqueId = (digits) => {
    var strong = typeof digits !== 'undefined' ? digits : 1000;
    return Date.now().toString(16) + Math.floor(strong * Math.random()).toString(16);
  };

  onConfirmEdit = (id) => {
    const { t, commonStore: { settingStore } } = this.props;
    const { ipadresses } = this.state;
    let trimedIpAddress = this.restrictionIpAddress.ipAddress.trim();
    let trimedComment = this.restrictionIpAddress.comment.trim();
    if (trimedIpAddress == "") {
      document.getElementById("required_msg_ipaddress").textContent = t("validate.field_is_empty");
    } else {
      let errmsg = Validate.validateIpAddress(trimedIpAddress, t);
      if (errmsg !== "") {
        document.getElementById("required_msg_ipaddress").textContent = errmsg;
      } else {
        for (const elem of ipadresses) {
          if (elem.id == id) {
            elem.ip_address = trimedIpAddress;
            elem.comment = trimedComment;
            if (!elem.status || elem.status == 'undefined') {
              elem.status = 2;
            }
            break;
          }
        }
        this.setState({ ipadresses });
        this.closeModal();
        this.restrictionIpAddress.ipAddress = "";
        this.restrictionIpAddress.comment = "";
      }
    }
  }

  onConfirmEditApiToken = () => {
    const { commonStore: { apiTokenStore } } = this.props;
    const payload = {
      id: this.apiToken.id,
      comment: this.apiToken.comment,
    }
    apiTokenStore.updateTenantToken(payload);
    this.closeModal();
  }

  openEditTokenModal = (apiToken) => {
    const { modalStore, t } = this.props;
    this.apiToken = JSON.parse(JSON.stringify(apiToken));

    modalStore.show({
      id: MODAL_ID.UPDATE_API_TOKEN,
      isOpen: true,
      header: t('api_token.modal.edit.page_title'),
      onCancel: this.closeModal,
      children: (
        <div className="text-c">
          <div key={"modal-body"} className="modal-body modal-add-item">
            <div className="row" style={{ paddingTop: "15px" }}>
              <div className="col-sm-1" />
              <div className="col-sm-4 font-bold">{t("api_token.modal.edit.token")}</div>
              <div className="col-sm-6" id="div_item_name">
                {this.apiToken.raw_token ? this.apiToken.raw_token : `tnt_********-****-****-****-********${this.apiToken.token_suffix}`}
              </div>
            </div>
            <div className="row" style={{ paddingTop: "15px" }}>
              <div className="col-sm-1" />
              <div className="col-sm-4 font-bold">{t("api_token.modal.edit.comment")}</div>
              <div className="col-sm-6" id="div_item_name">
                <input name="comment"
                  type="text"
                  maxLength={255}
                  onChange={(e) => this.onChangeApiToken(e)}
                  defaultValue={this.apiToken.comment}
                />
              </div>
            </div>
          </div>

          <ModalFooter key={"modal-footer"}
            saveButtonText={t('common.save')}
            onConfirm={this.onConfirmEditApiToken}
            saveButtonClass="btn-primary"
          />
        </div>
      ),
      type: 'medium'
    });
  };

  onConfirmRemoveApiToken = (id) => {
    const { commonStore: { apiTokenStore } } = this.props;
    apiTokenStore.deleteTenantToken(id);
    this.closeModal();
  }

  openDeleteTokenModal = (id) => {
    const { modalStore, t } = this.props;
    modalStore.show({
      id: MODAL_ID.REMOVE,
      isOpen: true,
      header: t('api_token.modal.delete.page_title'),
      onCancel: this.closeModal,
      children: (
        <div className="text-c">
          <div key={"modal-body"} className="modal-body">
            <span>{t('api_token.modal.delete.confirm_msg')}</span>
          </div>
          <ModalFooter key={"modal-footer"}
            saveButtonText={t('common.remove')}
            onConfirm={() => this.onConfirmRemoveApiToken(id)}
            cancelButtonText={t('common.cancel')}
            onCancel={this.closeModal}
            saveButtonClass="btn-primary"
          />
        </div>
      ),
      type: 'small'
    });
  };

  apiTokenColumn = () => {
    const { t } = this.props;
    return [
      {
        Header: t("common.no"),
        disableSortBy: true,
        width: TABLE_ROW_WIDTH_APITOKEN.NO,
        Cell: ({ row }) => <div style={{ textAlign: "center" }}>{row.index + 1}</div>
      },
      {
        Header: t('api_token.table.token'),
        accessor: 'apiToken',
        Cell: ({ row: { original } }) => {
          return (
            <div className="color-theme cursor-p">
              <span onClick={() => this.openEditTokenModal(original)}>{original.raw_token ? original.raw_token : `tnt_********-****-****-****-********${original.token_suffix}`}</span>
              {original.raw_token && <i className="fa fa-files-o" style={{ marginLeft: "12px" }} onClick={() => this.handleCopy(original.raw_token)}></i>}
            </div>
          );
        },
        width: TABLE_ROW_WIDTH_APITOKEN.TOKEN
      },
      {
        Header: t('api_token.table.comment'),
        accessor: 'comment',
        Cell: ({ row: { original } }) => {
          return (
            <div className="color-theme cursor-p" onClick={() => this.openEditTokenModal(original)}>
              {original.comment}
            </div>
          );
        },
        width: TABLE_ROW_WIDTH_APITOKEN.COMMENT
      },
      {
        Header: t('common.created_date'),
        accessor: 'createdAt',
        Cell: ({ row: { original } }) => {
          return (
            <div>
              {original.created_at ? moment(original.created_at).format(DATE_FORMAT.full_time) : NO_DATE}
            </div>
          );
        },
        width: TABLE_ROW_WIDTH_APITOKEN.CREATED_AT
      },
      {
        Header: '',
        id: 'remove',
        className: 'admin-action',
        Cell: ({ row: { original: { id } } }) => {
          return <div>
            <button className="btn btn-danger" type="button" onClick={() => this.openDeleteTokenModal(id)} style={{ fontSize: "12px", minWidth: "50px" }}>
              {t('common.remove')}
            </button>
          </div>
        },
        width: "80px",
      }
    ];
  }

  ipAddressColumn = () => {
    const { t } = this.props;
    return [
      {
        Header: t("common.no"),
        disableSortBy: true,
        width: TABLE_ROW_WIDTH_IPADDRESS.NO,
        Cell: ({ initialState, row }) => <div style={{ textAlign: "center" }}>{
          initialState?.initialTableState?.pageSize *
          initialState?.initialTableState?.pageIndex +
          row.index +
          1
        }</div>
        ,
      },
      {
        Header: t('general_setting.restriction_ip_address.ip'),
        accessor: 'ipAddress',
        Cell: ({ row: { original } }) => {
          return (
            <div className="color-theme cursor-p"
              onClick={() => this.openEditModal(original.id, original.ip_address, original.comment)}>
              {original.ip_address}
            </div>
          );
        },
        width: TABLE_ROW_WIDTH_IPADDRESS.IP_ADDRESS
      },
      {
        Header: t('general_setting.restriction_ip_address.comment'),
        accessor: 'comment',
        Cell: ({ row: { original } }) => {
          return (
            <div>
              {original.comment}
            </div>
          );
        },
        width: TABLE_ROW_WIDTH_IPADDRESS.COMMENT
      },
      {
        Header: t('common.created_date'),
        accessor: 'createdAt',
        Cell: ({ row: { original } }) => {
          return (
            <div>
              {original.created_at ? moment(original.created_at).format(DATE_FORMAT.full_time) : NO_DATE}
            </div>
          );
        },
        width: TABLE_ROW_WIDTH_IPADDRESS.CREATED_DATE
      },
      {
        Header: t('common.updated_date'),
        accessor: 'updatedAt',
        Cell: ({ row: { original } }) => {
          return (
            <div>
              {original.updated_at ? moment(original.updated_at).format(DATE_FORMAT.full_time) : NO_DATE}
            </div>
          );
        },
        width: TABLE_ROW_WIDTH_IPADDRESS.UPDATED_DATE
      },
      {
        Header: t("common.remove"),
        id: 'action',
        className: 'admin-action',
        Cell: ({ row: { original: { id } } }) => {
          return <div>
            <button className="btn btn-danger" type="button" onClick={() => this.openComfirmModal(id)} style={{ fontSize: "12px", minWidth: "50px" }}>
              {t('common.remove')}
            </button>
          </div>
        },
        width: "80px",
      }
    ];
  }

  render() {
    const { t } = this.props;
    const { commonStore: { settingStore: { paging }, apiTokenStore: { apiTokens } } } = this.props;
    const { threshold1, threshold2, apiKey, dataRetentionPeriod, enableDocumentDownload, downloadFolderName, downloadFileName,
      enableSpecifyCsvName, csvDownloadFolderName, csvDownloadFileName, enableOtp, restrictionIpAddress, ipadresses } = this.state;
    paging.size = 1000;

    return <div className="screen-general-setting">
      <ContainerBox headerTitle={t('menu.general_setting')} className="admin-sb-container">
        <Tabs selectedIndex={this.state.selectedIndexTab} onSelect={this.handleSelectTab}>
          <TabList>
            <Tab>{t("general_setting.tab.general")}</Tab>
            <Tab>{t("general_setting.tab.api")}</Tab>
          </TabList>

          {/* 一般タブ */}
          <TabPanel>
            <div className="box-body tab-general">
              <div className="row">
                <div className="col-sm-4 font-bold">
                  <span className="color-red">*</span>
                  {t("setting_definition.required")}
                </div>
              </div>
              <div className="row">
                <div className="col-sm-3 font-bold" style={{ lineHeight: "34px" }}>
                  {t("general_setting.threshold_title")}
                  <span className="color-red">*</span>
                </div>
                <div className="area col-sm-1">
                  <div className="high-area">
                    {t("general_setting.high")}
                  </div>
                </div>
                <div className="col-sm-2" style={{ textAlign: "center" }}>
                  <input style={{ maxWidth: "80px" }} type="number" value={threshold1} onChange={(value) => this.onChangeTheshold1(value.target.value)} ></input>
                </div>
                <div className="area col-sm-1">
                  <div className="mid-area">
                    {t("general_setting.mid")}
                  </div>
                </div>
                <div className="col-sm-2" style={{ textAlign: "center" }}>
                  <input style={{ maxWidth: "80px" }} type="number" value={threshold2} onChange={(value) => this.onChangeTheshold2(value.target.value)} ></input>
                </div>
                <div className="area col-sm-1">
                  <div className="low-area">
                    {t("general_setting.low")}
                  </div>
                </div>
              </div>
              {(!threshold1 || !threshold2)
                ? this.renderThresholdErr(t("validate.field_is_empty"))
                : (Validate.validateThreshold(threshold1, t) || Validate.validateThreshold(threshold2, t))
                  ? this.renderThresholdErr(Validate.validateThreshold(threshold1, t) || Validate.validateThreshold(threshold2, t))
                  : (threshold1 < threshold2) ? this.renderThresholdErr(t("validate.threshold_invalid")) : " "}
              <div className="row">
                <div className="col-sm-3 font-bold" style={{ lineHeight: "34px" }}>
                  {t("general_setting.data_retention_period")}
                  <span className="color-red">*</span>
                  <i className="fa fa-info-circle ar-tooltip"
                    data-toggle="tooltip"
                    data-placement="right"
                    title={t("general_setting.data_retention_period.tooltip")}>
                  </i>
                </div>
                {/* <div className="col-sm-1"></div> */}
                <div style={{ padding: "0px", display: "flex", flexDirection: "row" }} className="col-sm-7">
                  <div style={{ marginLeft: "125px" }}>
                    <input style={{ maxWidth: "80px" }} type="number"
                      min="0"
                      onKeyPress={this.handleKeyPressForNumber}
                      value={dataRetentionPeriod}
                      onChange={(value) => this.onChangeDataRetentionPeriod(value.target.value)} >
                    </input>
                    <span style={{ marginLeft: "10px" }}>{t("general_setting.day")}</span>
                    {Validate.validateDataRetentionPeriod(dataRetentionPeriod, t) !== ""
                      && <div className="err-msg">{Validate.validateDataRetentionPeriod(dataRetentionPeriod, t)}</div>
                    }
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-3 font-bold" style={{ lineHeight: "34px" }}>
                  {t("general_setting.specify_csv_name")}
                </div>
                <div style={{ padding: "0px", display: "flex", flexDirection: "row", lineHeight: "34px" }} className="col-sm-9">
                  <div className="enable-specify-csv-name">
                    <input type="radio" id="enable_specify_csv_name" name="enable_specify_csv_name"
                      value={ENABLE_SPECIFY_CSV_NAME.ENABLE}
                      checked={enableSpecifyCsvName === ENABLE_SPECIFY_CSV_NAME.ENABLE}
                      onChange={() => { }}
                      onClick={() => this.onChangeEnableSpecifyCsvName(ENABLE_SPECIFY_CSV_NAME.ENABLE)}>
                    </input>
                    <label htmlFor="enable_specify_csv_name" style={{ marginLeft: "8px" }}>
                      {t("general_setting.enable_specify_csv_name")}
                    </label>
                  </div>
                  <div className="enable-specify-csv-name" style={{ "marginLeft": "16px" }}>
                    <input type="radio" id="disable_specify_csv_name" name="disable_specify_csv_name"
                      value={ENABLE_SPECIFY_CSV_NAME.DISABLE}
                      checked={enableSpecifyCsvName === ENABLE_SPECIFY_CSV_NAME.DISABLE}
                      onChange={() => { }}
                      onClick={() => this.onChangeEnableSpecifyCsvName(ENABLE_SPECIFY_CSV_NAME.DISABLE)}>
                    </input>
                    <label htmlFor="disable_specify_csv_name" style={{ marginLeft: "8px" }}>
                      {t("general_setting.disable_specify_csv_name")}
                    </label>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-3 font-bold" style={{ lineHeight: "34px" }}></div>
                <div style={{ padding: "0px", display: "flex", flexDirection: "row" }} className="col-sm-9">
                  <div className="col-sm-6" style={{ padding: "0px", lineHeight: "34px" }}>
                    <span className="font-bold" style={{ paddingRight: "15px" }}>
                      {t("general_setting.csv_download_folder")}
                    </span>
                    <input style={{ width: "60%", textAlign: "left", marginRight: "15px" }} type="text"
                      maxLength="255" value={csvDownloadFolderName}
                      disabled={enableSpecifyCsvName === ENABLE_SPECIFY_CSV_NAME.DISABLE}
                      onChange={(value) => this.onChangeCsvDownloadFolderName(value.target.value)} >
                    </input>
                    {Validate.validateCsvDownloadFolderName(csvDownloadFolderName, t) !== ""
                      && <div className="err-msg">{Validate.validateCsvDownloadFolderName(csvDownloadFolderName, t)}</div>
                    }
                  </div>
                  <div className="col-sm-6" style={{ padding: "0px", lineHeight: "34px" }}>
                    <span className="font-bold" style={{ paddingRight: "15px" }}>
                      {t("general_setting.csv_download_file")}
                    </span>
                    <input style={{ width: "60%", textAlign: "left", marginRight: "15px" }} type="text"
                      maxLength="255" value={csvDownloadFileName}
                      disabled={enableSpecifyCsvName === ENABLE_SPECIFY_CSV_NAME.DISABLE}
                      onChange={(value) => this.onChangeCsvDownloadFileName(value.target.value)} >
                    </input>
                    {Validate.validateCsvDownloadFileName(csvDownloadFileName, t) !== ""
                      && <div className="err-msg">{Validate.validateCsvDownloadFileName(csvDownloadFileName, t)}</div>
                    }
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-3 font-bold" style={{ lineHeight: "34px" }}>
                  {t("general_setting.document_download")}
                </div>
                <div style={{ padding: "0px", display: "flex", flexDirection: "row", lineHeight: "34px" }} className="col-sm-9">
                  <div className="enable-document-download">
                    <input type="radio" id="enable_document_download" name="enable_document_download"
                      value={ENABLE_DOCUMENT_DOWNLOAD.ENABLE}
                      checked={enableDocumentDownload === ENABLE_DOCUMENT_DOWNLOAD.ENABLE}
                      onChange={() => { }}
                      onClick={() => this.onChangeEnableDocumentDownload(ENABLE_DOCUMENT_DOWNLOAD.ENABLE)}>
                    </input>
                    <label htmlFor="enable_document_download" style={{ marginLeft: "8px" }}>
                      {t("general_setting.enable_document_download")}
                    </label>
                  </div>
                  <div className="enable-document-download" style={{ "marginLeft": "16px" }}>
                    <input type="radio" id="disable_document_download" name="enable_document_download"
                      value={ENABLE_DOCUMENT_DOWNLOAD.DISABLE}
                      checked={enableDocumentDownload === ENABLE_DOCUMENT_DOWNLOAD.DISABLE}
                      onChange={() => { }}
                      onClick={() => this.onChangeEnableDocumentDownload(ENABLE_DOCUMENT_DOWNLOAD.DISABLE)}>
                    </input>
                    <label htmlFor="disable_document_download" style={{ marginLeft: "8px" }}>
                      {t("general_setting.disable_document_download")}
                    </label>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-3 font-bold" style={{ lineHeight: "34px" }}></div>
                <div style={{ padding: "0px", display: "flex", flexDirection: "row" }} className="col-sm-9">
                  <div className="col-sm-6" style={{ padding: "0px", lineHeight: "34px" }}>
                    <span className="font-bold" style={{ paddingRight: "15px" }}>
                      {t("general_setting.document_download_folder")}
                    </span>
                    <input style={{ width: "60%", textAlign: "left", marginRight: "15px" }} type="text"
                      maxLength="255" value={downloadFolderName}
                      disabled={enableDocumentDownload === ENABLE_DOCUMENT_DOWNLOAD.DISABLE}
                      onChange={(value) => this.onChangeDownloadFolderName(value.target.value)} >
                    </input>
                    {Validate.validateDownloadFolderName(downloadFolderName, t) !== ""
                      && <div className="err-msg">{Validate.validateDownloadFolderName(downloadFolderName, t)}</div>
                    }
                  </div>
                  <div className="col-sm-6" style={{ padding: "0px", lineHeight: "34px" }}>
                    <span className="font-bold" style={{ paddingRight: "15px" }}>
                      {t("general_setting.document_download_file")}
                    </span>
                    <input style={{ width: "60%", textAlign: "left", marginRight: "15px" }} type="text"
                      maxLength="255" value={downloadFileName}
                      disabled={enableDocumentDownload === ENABLE_DOCUMENT_DOWNLOAD.DISABLE}
                      onChange={(value) => this.onChangeDownloadFileName(value.target.value)} >
                    </input>
                    {Validate.validateDownloadFileName(downloadFileName, t) !== ""
                      && <div className="err-msg">{Validate.validateDownloadFileName(downloadFileName, t)}</div>
                    }
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-3 font-bold" style={{ lineHeight: "34px" }}></div>
                <div style={{ padding: "0px" }} className="col-sm-9">
                  {t("general_setting.document_download_description_before_link")}
                  <a target="_blank" href="https://manual.airead.ai/usersmanual/oncloud/12-%e7%92%b0%e5%a2%83%e8%a8%ad%e5%ae%9a%e7%94%bb%e9%9d%a2/#:~:text=5-,CSV%E3%83%80%E3%82%A6%E3%83%B3%E3%83%AD%E3%83%BC%E3%83%89%E3%83%95%E3%82%A1%E3%82%A4%E3%83%AB%E5%90%8D%E6%8C%87%E5%AE%9A,-%E3%83%95%E3%82%A9%E3%83%AB%E3%83%80%E3%83%BB%E3%83%95%E3%82%A1%E3%82%A4%E3%83%AB%E5%90%8D">
                    {t("general_setting.document_download_description_link")}
                  </a>
                  {t("general_setting.document_download_description_after_link")}
                </div>
              </div>
              {URL_CONFIG.is_connect_to_azure_app_insight === true &&
                <div className="row">
                  <div className="col-sm-3 font-bold" style={{ lineHeight: "34px" }}>
                    {t("general_setting.otp_setting")}
                  </div>
                  <div style={{ padding: "0px", display: "flex", flexDirection: "row", lineHeight: "34px" }} className="col-sm-9">
                    <div className="enable-otp">
                      <input type="radio" id="enable_otp" name="enable_otp"
                        value={ENABLE_OTP.ENABLE}
                        checked={enableOtp === ENABLE_OTP.ENABLE}
                        onChange={() => { }}
                        onClick={() => this.onChangeEnableOtp(ENABLE_OTP.ENABLE)}>
                      </input>
                      <label htmlFor="enable_otp" style={{ marginLeft: "8px" }}>
                        {t("general_setting.enable_otp")}
                      </label>
                    </div>
                    <div className="enable-otp" style={{ "marginLeft": "16px" }}>
                      <input type="radio" id="disable_otp" name="enable_otp"
                        value={ENABLE_OTP.DISABLE}
                        checked={enableOtp === ENABLE_OTP.DISABLE}
                        onChange={() => { }}
                        onClick={() => this.onChangeEnableOtp(ENABLE_OTP.DISABLE)}>
                      </input>
                      <label htmlFor="disable_otp" style={{ marginLeft: "8px" }}>
                        {t("general_setting.disable_otp")}
                      </label>
                    </div>
                  </div>
                </div>
              }
              <div className="row" style={{ margin: "0px", padding: "0px", marginLeft: "5px", paddingLeft: "5px" }}>
                <div className="col-sm-3 font-bold" style={{ lineHeight: "34px" }}>
                  {t("general_setting.restriction_ip_address")}
                </div>
                <div style={{ padding: "0px", display: "flex", flexDirection: "row" }} className="col-sm-9">
                  <Switch
                    onChange={(value) => this.onChangeRestrictionIpAddress(value)}
                    checked={restrictionIpAddress === 0}
                    height={25}
                    width={65}
                  />
                  <div style={{ marginLeft: "auto" }} className="col-sm-9">
                    <button
                      className="ip-address-btn-style btn btn-primary f-r mb-3 btn-ip-addresss-man"
                      type="button"
                      onClick={this.openAddModal}
                      style={{ fontSize: "12px" }}
                    >
                      {t("general_setting.restriction_ip_address.create")}
                    </button>
                  </div>
                </div>
              </div>
              <div className="row" style={{ margin: "0px", padding: "0px" }} >
                <div className="col-sm-3 font-bold" />
                <div className="col-sm-9" style={{ fontSize: "12px", padding: "0px" }}>
                  <div className="box-body-content">
                    <Table
                      columns={this.ipAddressColumn()}
                      data={ipadresses}
                      disablePaging={true}
                      disableSelectionPageSize={true}
                      onFetch={this.onFetch}
                      enableServerSidePaging={true}
                      initialTableState={paging}
                      hideTableFooter={false}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="save-row">
              <div className="col-sm-12" style={{ textAlign: "center" }}>
                <button className="btn btn-primary" onClick={this.handleSubmit}>{t("general_setting.save")}</button>
              </div>
            </div>
          </TabPanel>

          {/* APIタブ */}
          <TabPanel>
            <div className="box-body tab-api">
              <div className="row">
                <div className="col-sm-3 font-bold" style={{ lineHeight: "34px" }}>
                  {t("api_token")}
                </div>
                <div style={{ padding: "0px", display: "flex", flexDirection: "row" }} className="col-sm-9">
                  <button className="btn btn-primary" onClick={this.handleGenerate} style={{ height: "32px", minWidth: "80px" }}>{t("api_token.generate")}</button>
                </div>
              </div>
              {
                apiTokens && apiTokens.length > 0 &&
                <div className="row" style={{ margin: "0px", padding: "0px" }} >
                  <div className="col-sm-3 font-bold" />
                  <div className="col-sm-9" style={{ fontSize: "12px", padding: "0px" }}>
                    <div className="box-body-content">
                      <Table
                        columns={this.apiTokenColumn()}
                        data={apiTokens}
                        disablePaging={true}
                        disableSelectionPageSize={true}
                        enableServerSidePaging={false}
                        hideTableFooter={true}
                        className="tbl-header"
                      />
                    </div>
                  </div>
                </div>
              }
            </div>
          </TabPanel>
        </Tabs>
      </ContainerBox>
    </div >
  }
}

export default withRouter(withTranslation()(GeneralSetting));
